import { render, staticRenderFns } from "./storeByProductOrder.vue?vue&type=template&id=70f5edd5&scoped=true"
import script from "./storeByProductOrder.vue?vue&type=script&lang=js"
export * from "./storeByProductOrder.vue?vue&type=script&lang=js"
import style0 from "./storeByProductOrder.vue?vue&type=style&index=0&id=70f5edd5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f5edd5",
  null
  
)

export default component.exports